import dayjs from 'dayjs';
var DateUtils = /** @class */ (function () {
    function DateUtils() {
    }
    DateUtils.stringBrToDate = function (date) {
        if (date === undefined)
            return null;
        if (date.length > 10)
            date = date.substring(0, 10);
        var split = date.split('/');
        var dia = Number(split[0]);
        var mes = Number(split[1]) - 1;
        var ano = Number(split[2]);
        return new Date(ano, mes, dia);
    };
    DateUtils.formatDate = function (date) {
        var day = date.getDate().toString().padStart(2, '0');
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var year = date.getFullYear();
        return "".concat(day, "/").concat(month, "/").concat(year);
    };
    DateUtils.formatDateStrToBRWithTime = function (dateString) {
        var date = new Date(dateString);
        return DateUtils.formatDateWithTime(date);
    };
    DateUtils.formatDateWithTime = function (date) {
        var day = date.getDate().toString().padStart(2, '0');
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var year = date.getFullYear();
        var hours = date.getHours().toString().padStart(2, '0');
        var minutes = date.getMinutes().toString().padStart(2, '0');
        return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hours, ":").concat(minutes);
    };
    DateUtils.formatDateWithFullTime = function (date) {
        var day = date.getDate().toString().padStart(2, '0');
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var year = date.getFullYear();
        var hours = date.getHours().toString().padStart(2, '0');
        var minutes = date.getMinutes().toString().padStart(2, '0');
        var seconds = date.getSeconds().toString().padStart(2, '0');
        return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    };
    DateUtils.formatDateToBR = function (dateString) {
        var date = new Date(dateString);
        var day = date.getDate().toString().padStart(2, '0');
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var year = date.getFullYear();
        return "".concat(day, "/").concat(month, "/").concat(year);
    };
    DateUtils.formatDateEs = function (date) {
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var day = date.getDate().toString().padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
    };
    DateUtils.getTime = function (date) {
        if (!date)
            return null;
        return new Date(date).getTime();
    };
    DateUtils.getYear = function (date) {
        if (!date)
            return null;
        return new Date(date).getFullYear();
    };
    DateUtils.dataByYear = function (year) {
        if (!year) {
            return null;
        }
        return new Date("".concat(year, "-01-02 23:59:59"));
    };
    DateUtils.getDateJs = function () {
        var dataAtual = new Date();
        var month = (dataAtual.getMonth() + 1).toString().padStart(2, '0');
        var day = dataAtual.getDate().toString().padStart(2, '0');
        var year = dataAtual.getFullYear();
        return dayjs("".concat(year, "-").concat(month, "-").concat(day));
    };
    return DateUtils;
}());
export { DateUtils };
